import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import {
  IRole,
  IRoleListRequest,
  IRoleListResponse,
  IGenericResponse,
  IModulePermission,
} from '../../state/models/role.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class RoleService {
  private readonly baseUrl = `${environment.roleEndpoint}/api/role-permission`;

  constructor(private readonly api: ApiService) {}

  // 1. Get role by ID
  getRole(id: string): Promise<IGenericResponse<IRole>> {
    return this.api.get<IGenericResponse<IRole>>(`${this.baseUrl}/${id}`);
  }

  // 2. List roles with filter/sort
  listRoles(body: IRoleListRequest): Promise<IRoleListResponse> {
    return this.api.post(`${this.baseUrl}/list`, body);
  }

  // 3. Update role by ID
  updateRole(id: string, payload: IRole): Promise<IGenericResponse<IRole>> {
    return this.api.put(`${this.baseUrl}/${id}`, payload);
  }

  // 4. Change role status (PATCH)
  changeRoleStatus(id: string): Promise<IGenericResponse<IRole>> {
    return this.api.patch(`${this.baseUrl}/${id}`, {});
  }

  // 5. Delete role
  deleteRole(id: string): Promise<IGenericResponse<IRole>> {
    return this.api.delete(`${this.baseUrl}/${id}`);
  }

  // 6. Get role names
  getRoleNames(): Promise<
    IGenericResponse<{ roles: { _id: string; name: string }[] }>
  > {
    return this.api.post(`${this.baseUrl}/roles`, {});
  }

  // 7. Get permission structure
  getPermissions(): Promise<
    IGenericResponse<{ permissions: IModulePermission[] }>
  > {
    return this.api.get(`${this.baseUrl}/permissions`);
  }

  // 8. Get system role permissions
  getSystemRolePermissions(): Promise<IGenericResponse<IRole[]>> {
    return (
      this.api.get<IGenericResponse<IRole[]>>(`${this.baseUrl}/systemRolePermissions`)
    );
  }
  getRolesNames(): Promise<IGenericResponse<IRole[]>> {
    return (
      this.api.get<IGenericResponse<IRole[]>>(`${this.baseUrl}/roles/all`)
    );
  }
}
